import useFirebase from "../../../../../useFirebase";
import { useSelector, useDispatch } from "react-redux";
import { setShowMessage, setErrorInfo } from "../../../AxiosRtk/successMessage";

function useWebMonitor(device, webMonitoringData, setWebCategoryData) {
    const {
        getCollectionData,
        postCollectionData,
        createCollectionData
    } = useFirebase();
    const dispatch = useDispatch();
    const {
        setRulesData
    } = useSelector(({ setRules }) => setRules);

    function callFireStore(payload) {
        const newPayload = {
            setRulesActiveInActiveStatus: {...setRulesData?.setRulesActiveInActiveStatus, webMonitoringEnabled: payload?.webMonitoringEnabled},
            webmonitoring: payload
        };

        if (setRulesData) {
            postCollectionData(device, newPayload);
        } else {
            createCollectionData(device, newPayload);
        }
        getCollectionData(device);
    }

    function handleToggleChange(e) {
        const { name, checked } = e.target;
        const collectionPayload = {
            ...webMonitoringData
        }

        if (name === 'WEB_MONITORING_ENABLE') {
            collectionPayload['webMonitoringEnabled'] = checked
        } else if (name === 'ALLOW_ALL_MONITOR_ONLY') {
            collectionPayload['webSupervisionType'] = 0
        } else if (name === 'BLOCK_SELECTED_WEBSITES') {
            collectionPayload['webSupervisionType'] = 1
        } else if (name === 'BLOCK_ALL') {
            collectionPayload['webSupervisionType'] = 2
        } else if (name === 'SAFE_SEARCH_YOUTUBE') {
            collectionPayload['safeSearchYoutube'] = checked
        } else if (name === 'SAFE_SEARCH') {
            collectionPayload['safeSearch'] = checked
        } else if (name === 'ENFORCE_SAFE_SEARCH_GOOGLE') {
            collectionPayload['enforceSafeSearchGoogle'] = checked
            collectionPayload['enforceSafeSearchYoutube'] = checked
            collectionPayload['enforceSafeSearchBing'] = checked
        }
        
        callFireStore(collectionPayload);
    }

    function handleWebCategoryChange(e) {
        const { id, checked } = e.target;
        if (webMonitoringData) {
            const webCategories = [...webMonitoringData?.webCategory];
            const itemIndex = webCategories?.findIndex((item) => parseInt(item?.id) === parseInt(id));
            const itemToUpdate = { ...webCategories[itemIndex] };
            itemToUpdate['isChecked'] = checked;

            webCategories?.splice(itemIndex, 1, itemToUpdate);

            const payload = {
                ...webMonitoringData,
                webCategory: webCategories
            }

            setWebCategoryData(payload);
        }
    }

    function handleAllSelect(e) {
        const { checked } = e.target;
        if (webMonitoringData) {
            let webCategories = [...webMonitoringData?.webCategory];
            let webArr = [];
            webCategories.forEach((item) => {
                if (item.name) {
                    webArr.push(item)
                }
            })

            webCategories = webArr?.map((item) => {
                const tempObj = { ...item }
                tempObj['isChecked'] = checked
                return tempObj
            })
            const payload = {
                ...webMonitoringData,
                webCategory: [...webCategories]
            }

            setWebCategoryData(payload);
        }
    }

    function handleCategoryStatusChange(status) {
        let webCategories = [...webMonitoringData?.webCategory];
        const clickChecked = webCategories?.filter((item) => item?.isChecked);
        if (clickChecked?.length === 0) {
            dispatch(setErrorInfo({
                errorInfo: true,
                title: "CATEGORY_NOT_SELECTED",
                defaultTitle: "Category not selected"
            }))
            return;
        }

        if (status === 'ALLOW') {
            webCategories = webCategories?.map((item) => {
                const obj = { ...item };
                if (obj['isChecked']) {
                    obj['categoryStatus'] = 0
                    delete obj['isChecked'];
                }
                return obj;
            })
        } else if (status === 'BLOCK') {
            webCategories = webCategories?.map((item) => {
                const obj = { ...item };
                if (obj['isChecked']) {
                    obj['categoryStatus'] = 1
                    delete obj['isChecked'];
                }
                return obj;
            })
        } else if (status === 'WARN') {
            webCategories = webCategories?.map((item) => {
                const obj = { ...item };
                if (obj['isChecked']) {
                    obj['categoryStatus'] = 2
                    delete obj['isChecked'];
                }
                return obj;
            })
        }

        const collectionPayload = {
            ...setRulesData?.webmonitoring,
            webCategory: [...webCategories]
        }

        callFireStore(collectionPayload);
        if (status === 'ALLOW') {
            dispatch(setShowMessage({
                showMessage: true,
                message: "CATEGORY_ALLOWED_SUCCESS_MSG",
                defaultMessage: "Category allowed successfully"
            }))
        } else if (status === 'WARN') {
            dispatch(setShowMessage({
                showMessage: true,
                message: "CATEGORY_WARN_SUCCESS_MSG",
                defaultMessage: "Category warned successfully"
            }))
        } else {
            dispatch(setShowMessage({
                showMessage: true,
                message: "CATEGORY_BLOCKED_SUCCESS_MSG",
                defaultMessage: "Category blocked successfully"
            }))
        }
    }

    return {
        handleToggleChange,
        handleWebCategoryChange,
        handleAllSelect,
        handleCategoryStatusChange
    }

}

export default useWebMonitor;